import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { BottomTabBar } from './BottomTabBar';

/**
 * Shell (PEL-817) — root layout for all authenticated routes under `/app/*`.
 *
 * Breakpoint behavior:
 *   <768px  : TopBar + <Outlet/> + BottomTabBar   (mobile web)
 *   768-1023: Sidebar rail (icon only) + TopBar + <Outlet/>   (tablet)
 *   ≥1024px : Sidebar (full) + TopBar + <Outlet/>   (desktop)
 *
 * Content area scrolls; TopBar and Sidebar are sticky. BottomTabBar is
 * fixed to the viewport bottom on mobile and adds bottom padding so the
 * scrolling content never hides underneath it.
 */
export function Shell() {
  return (
    <div className="min-h-screen flex bg-[var(--background)] text-[var(--text)]">
      <Sidebar />

      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main
          className="flex-1 min-w-0 pb-[calc(env(safe-area-inset-bottom)+64px)] md:pb-0"
          role="main"
        >
          <Outlet />
        </main>
      </div>

      <BottomTabBar />
    </div>
  );
}
